import { useState } from "react";

let idGenerator = 0;

/** @type {() => string} */
export const useId = () => {
  const [id] = useState(() => ++idGenerator);
  return `${id}`;
};
